<template>
  <div id="google-map" ref="google-map" class="presenter-view-google-map"></div>
</template>

<script>
export default {
  name: 'GoogleMapPresenterView',

  data() {
    return {
      map: null,
      bounds: null,
      markers: []
    }
  },

  props: {
    presenterData: Array,
    clickOnHospital: Function
  },

  mounted() {
    const element = this.$refs['google-map']
    const options = {
      controlSize: 20,
      backgroundColor: '#CCCCCC',
      minZoom: 3,
      zoom: 4,
      maxZoom: 15,
      center: {lat: 51.693972, lng: -2.193821},
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      styles: [
        {
          featureType: 'all',
          stylers: [{color: '#CCCCCC'}]
        },
        {
          elementType: 'labels',
          stylers: [{visibility: 'off'}]
        },
        {
          featureType: 'water',
          stylers: [{color: '#FFFFFF'}]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [{color: '#FFFFFF'}]
        }
      ]
    }

    // eslint-disable-next-line
    this.map = new google.maps.Map(element, options)

    // if number of hospitals is 1 then zoom to a bigger map
    if(this.presenterData.length === 1) {
      // eslint-disable-next-line
      this.bounds = new google.maps.LatLngBounds(
        // eslint-disable-next-line
        new google.maps.LatLng(0, -100),
        // eslint-disable-next-line
        new google.maps.LatLng(0, 100)
      )
    // else google maps will automaticaly zoom by the location of hospitals
    } else {
      // eslint-disable-next-line
      this.bounds = new google.maps.LatLngBounds()
    }

    this.populateMap()
    this.map.addListener('bounds_changed', () => {
      this.emitBounds()
    })

    this.map.addListener('zoom_changed', () => {
      this.emitZoom()
    })
  },

  watch: {
    presenterData: function() {
      this.populateMap()
    }
  },

  methods: {
    clearMap() {
      for(let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null)
      }
      this.markers.length = 0
    },

    populateMap() {
      this.clearMap()
      this.presenterData.forEach(({patient_numbers, hospital}) => {
        // eslint-disable-next-line
        const position = new google.maps.LatLng(hospital.latlng[0], hospital.latlng[1])

        const locationIcon = {
          path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 ' +
              '9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
          // eslint-disable-next-line
          anchor: new google.maps.Point(12, 24),
          scale: 1.8,
          strokeColor: '#3FA4D0',
          fillColor: '#3FA4D0',
          fillOpacity: 1
        }

        // eslint-disable-next-line
        const markerWithLabel = new MarkerWithLabel({
          position: {lat: hospital.latlng[0], lng: hospital.latlng[1]},
          map: this.map,
          icon: locationIcon,
          labelContent: patient_numbers.length,
          // eslint-disable-next-line
          labelAnchor: new google.maps.Point(-25, 40),
          labelClass: 'label-custom-class',
          labelInBackground: true
        })

        this.markers.push(markerWithLabel)
      })
    },

    emitBounds() {
      this.$emit('boundsChange', this.map.getBounds())
    },

    emitZoom() {
      this.$emit('zoomChange', this.map.getZoom())
    }
  }
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'

.presenter-view-google-map
  &#google-map
    width: 100%
    height: 100%
    box-shadow: 0 0 5px $color-shadow
    background-color: $color-panel-bg

  .label-custom-class
    color: #3FA4D0
    font-size: 30px
    font-weight: 500
</style>


// WEBPACK FOOTER //
// src/components/GoogleMapPresenterView.vue